module.exports = __webpack_public_path__ + "img/aboutWMA.3499a4f9.jpg";